module.exports = __webpack_public_path__ + "media/images/emblems/Vendlincourt-coat_of_arms-96c522eb3c07d90d2a92facc5e09b3c9.svg";